import { useContext } from 'react';
import { createContext } from 'react';

import { ProductHighlightTextProps } from '../@types/ProductHighlightTextProps';

export const ProductHighlightTextContext = createContext<ProductHighlightTextProps>({} as ProductHighlightTextProps);

ProductHighlightTextContext.displayName = 'ProductHighlightText';

const ProductHighlightTextProvider = (props: ProductHighlightTextProps) => (
	<ProductHighlightTextContext.Provider value={props}>{props.children}</ProductHighlightTextContext.Provider>
);

export const useProductHighlightText = () => {
	const context = useContext(ProductHighlightTextContext);

	return context;
};

export default ProductHighlightTextProvider;
